import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from '@nosto/preact'
import { hasTag, hasTagStartingWith, findTagStartingWith, getCustomFieldValue } from '../helpers.js'
import Prices from './Prices'

export default function Product({ product }) {
    const { format } = useCurrencyFormatting()

    const extension = getCustomFieldValue(product, 'additional_info-title_extension') || ''

    // Render top badges
    const renderTopBadges = () => {
        if (product.availability !== 'InStock') {
            return <div class="badge badge--sold-out">LOPPU VERKOSTA</div>
        } else if (hasTag(product, 'Merkintä:Store only')) {
            return <div class="badge badge--store">VAIN MYYMÄLÖISTÄ</div>
        } else if (hasTag(product, 'Merkintä:Outlet')) {
            return <div class="badge badge--outlet">OUTLET</div>
        } else if (hasTagStartingWith(product, '_friends')) {
            return <div class="badge badge--friends">KLUBIHINTA</div>
        } else if (product.listPrice > product.price) {
            return <div class="badge badge--sale">ALE</div>
        } else if (hasTag(product, 'Merkintä:Uutuus')) {
            return <div class="badge badge--new">Uutuus</div>
        }
        return null
    }

    // Render bottom badges
    const renderBottomBadges = () => {
        if (hasTag(product, 'Merkintä:Puuvillasatiinia')) {
            return (
                <div class="badge-wrapper__bottom">
                    <div class="badge badge--made-in-finland">PUUVILLASATIINIA</div>
                </div>
            )
        } else if (getCustomFieldValue(product, 'additional_info-country_of_manufacture') === 'Suomi') {
            return (
                <div class="badge-wrapper__bottom">
                    <div class="badge badge--made-in-finland">Valmistettu Suomessa</div>
                </div>
            )
        } else if (product.listPrice > product.price) {
            // Calculate discount percentage
            const discountPercent = Math.round((1 - product.price / product.listPrice) * 100)
            return (
                <div class="badge-wrapper__bottom">
                    <span class="grid-product__price--savings">-{discountPercent}%</span>
                </div>
            )
        }
        return null
    }

    // Render image
    const renderImage = () => {
        // Clean image URL by removing _750x750 if present
        const cleanedUrl = product.imageUrl.replace('_750x750', '')

        // Generate data-bgset attribute value
        const sizes = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728]
        const bgset = sizes
            .map((size) => {
                const sizedImageUrl = cleanedUrl.replace('.png', `_${size}x.png`)
                return `${sizedImageUrl} ${size}w ${size}h`
            })
            .join(',\n')

        // Generate background-image style value
        const backgroundImage = `background-image: url('${cleanedUrl.replace('.png', '_360x.png')}');`

        return (
            <div
                class="grid__image-ratio grid__image-ratio--square lazyloaded"
                data-bgset={bgset}
                style={backgroundImage}></div>
        )
    }

    // ATC
    const handleAddToCart = (e) => {
        e.preventDefault()
        e.stopPropagation()

        const skuId = product.skus[0].id
        const productId = product.productId

        Nosto.addSkuToCart({ productId: productId, skuId: skuId }).then(() => {
            document.body.dispatchEvent(new CustomEvent('addedAjaxProduct'))
        })
    }
    return (
        <SerpElement
            as="div"
            hit={product}
            ariaLabel={`Product ${product.name}`}
            class="grid__item grid-product small--one-half medium-up--one-quarter aos-init aos-animate">
            <div class="grid-product__content">
                <div class="badge-wrapper">{renderTopBadges()}</div>
                <a href={product.url} class="grid-product__link">
                    <div class="grid-product__image-mask">
                        {renderImage()}
                        <button
                            class="nosto-atc nosto-btn btn btn--full add-to-cart"
                            onClick={handleAddToCart}>
                            Lisää ostoskoriin
                        </button>
                        {renderBottomBadges()}
                    </div>
                    <div class="grid-product__meta">
                        <div class="grid-product__title grid-product__title--body">{product.name}</div>
                        <div class="grid-product__extension">{extension}</div>
                        <Prices product={product} />
                    </div>
                </a>
            </div>
        </SerpElement>
    )
}
